// External libraries
import gql from 'graphql-tag';

export const NORMALIZED_ADDRESSES_FRAGMENT = gql`
  fragment AddressNormalizationFragment on NormalizedAddress {
    line1
    line2
    city
    state
    postalCode
    alreadyNormalized
    griffinFormattedAddresses {
      formattedOriginalAddress
      formattedNormalizedAddress
    }
  }
`;
